module.exports = __webpack_public_path__ + "img/Bounce™.10a4b1bc.jpg";